import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PolicyModel } from "src/app/models/api/governance/policy.model";

export const DateTimeFormat = "M/d/yy";

@Component({
    selector: "app-policy-box",
    templateUrl: "./policy-box.component.html",
    styleUrls: ["./policy-box.component.scss"],
})
export class PolicyBoxComponent implements OnInit {
    @Input() public policyModel: PolicyModel;
    @Input() public environments?: string[];
    @Input() public reachedMaxNumberOfPolicies = false;
    @Input() public canAddOrDelete = false;
    @Output() public duplicatePolicyHandle = new EventEmitter<PolicyModel>();
    @Output() public deletePolicyHandle = new EventEmitter<PolicyModel>();
    @Output() public policyHandle = new EventEmitter<PolicyModel>();

    public environmentsString = "";

    ngOnInit(): void {
        if (this.environments) this.environmentsString = this.environments?.slice(1).join("\n");
    }

    public policyClicked() {
        this.policyHandle.emit(this.policyModel);
    }

    public duplicatePolicyClicked(event: Event) {
        event.stopPropagation(); // avoid moving to policy single page
        this.duplicatePolicyHandle.emit(this.policyModel);
    }

    public deletePolicyClicked(event: Event) {
        event.stopPropagation(); // avoid moving to policy single page
        this.deletePolicyHandle.emit(this.policyModel);
    }
}
